import { GTMEvent } from "@/helpers/gtm/GTMEvent.ts";
import { useEffect } from "react";
import TagManager from "react-gtm-module";

export const useGTMReservedPage = () => {
  useEffect(() => {
    TagManager.dataLayer({ dataLayer: { event: GTMEvent.VirtualPageView, page: "thankYouScreen" } });
  }, []);
};
